import diffMethods from './methods';

function createApplier(obj, config) {
    if (!config || !config.idKey) {
        throw new Error('Missing second parameter config with idKey property');
    }
    const idKey = config.idKey;
    const locale = config.locale;

    return function (change) {
        if (change.type === 'changed') {
            diffMethods.updater(obj, change.key, idKey)(change.value);
        } else if (change.type === 'removed') {
            diffMethods.remover(obj, change.key, idKey)(change.value);
        } else if (change.type === 'added') {
            diffMethods.adder(obj, change.key, idKey)(change.value, change.index);
        } else if (change.type === 'reordered') {
            diffMethods.reorder(obj, change.key, idKey)(change.parts);
        } else if (change.type === 'localized-updated') {
            const localizedStringChange = change.value[locale] || change.value['default'];
            diffMethods.updater(obj, change.key, idKey)(localizedStringChange);
        }
    };
}

export default { createApplier };
